import { defineMessages } from 'react-intl';

export default defineMessages({
  createIssue: {
    id: 'frontbucket.jiraTab.header.createIssue',
    description: 'Button to create a new Jira issue',
    defaultMessage: 'Create issue',
  },
});
